
import React from 'react';
const UpIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_350_7006)">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.293 8.29363C11.4805 8.10615 11.7348 8.00079 12 8.00079C12.2651 8.00079 12.5194 8.10615 12.707 8.29363L18.364 13.9506C18.4595 14.0429 18.5357 14.1532 18.5881 14.2752C18.6405 14.3972 18.6681 14.5284 18.6693 14.6612C18.6704 14.794 18.6451 14.9257 18.5948 15.0486C18.5445 15.1715 18.4703 15.2832 18.3764 15.3771C18.2825 15.471 18.1708 15.5453 18.048 15.5956C17.9251 15.6458 17.7934 15.6711 17.6606 15.6699C17.5278 15.6687 17.3966 15.6411 17.2746 15.5887C17.1526 15.5363 17.0423 15.4601 16.95 15.3646L12 10.4146L7.04998 15.3646C6.86141 15.5468 6.6088 15.6476 6.3466 15.6453C6.0844 15.643 5.83357 15.5378 5.64816 15.3524C5.46275 15.167 5.35758 14.9162 5.3553 14.654C5.35302 14.3918 5.45381 14.1392 5.63598 13.9506L11.293 8.29363Z" fill="black"/>
        </g>
        <defs>
            <clipPath id="clip0_350_7006">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export default UpIcon;